// extracted by mini-css-extract-plugin
export default {"container":"ExtensionListContent_container__v0KDE","title":"ExtensionListContent_title__bDymh"};